import { CheckCircle, Cloud } from 'lucide-react';

function DriveStatusBanner({ driveConnected }) {
  if (driveConnected) {
    return (
      <div className="mb-4 sm:mb-6 bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-200 dark:border-emerald-700 rounded-xl p-3 sm:p-4 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <CheckCircle className="w-5 h-5 text-emerald-600 dark:text-emerald-400" />
          <div>
            <p className="text-sm font-medium text-emerald-900 dark:text-emerald-100">Google Drive Connected</p>
            <p className="text-xs text-emerald-700 dark:text-emerald-300 hidden sm:block">Invoices will be automatically backed up</p>
          </div>
        </div>
        <Cloud className="w-6 h-6 text-emerald-600 dark:text-emerald-400" />
      </div>
    );
  }

  return (
    <div className="mb-4 sm:mb-6 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-700 rounded-xl p-3 sm:p-4 hidden sm:block">
      <div className="flex items-start space-x-3">
        <Cloud className="w-5 h-5 text-blue-600 dark:text-blue-400 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="text-sm font-medium text-blue-900 dark:text-blue-100">Google Drive Integration (Optional)</p>
          <p className="text-xs text-blue-700 dark:text-blue-300 mt-1">
            You can download Excel files locally without setting up Google Drive. To enable automatic Drive backup, configure OAuth credentials in Settings.
          </p>
        </div>
      </div>
    </div>
  );
}

export default DriveStatusBanner;
